/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const dashboardAPI = {
  admin: async () => {
    const { data } = await apiClient.get('/dashboard/admin');
    return data;
  },

  tecnico: async () => {
    const { data } = await apiClient.get('/dashboard/tecnico');
    return data;
  },

  report: async (params = {}) => {
    const { data } = await apiClient.get('/dashboard/report', { params });
    return data;
  },
};
